export default "__VITE_ASSET__DCMUKFjS__"